import useBindings from "@/lib/useBindings";

/**
 * Picker for a Brand Kit binding slug. Sourced from /api/brand-kit/bindings
 * (the registry — same data feeding the BrandKit forms). The stored value
 * is the slug; the AI Assembly Agent (M3.3) resolves the actual asset.
 */
export default function BindingSlugPicker({ value, onChange, brandId, assetClass, testid }) {
  const { bindings, loading } = useBindings(assetClass, brandId);

  if (loading) {
    return <p className="text-xs text-[#6B6358]">Loading {assetClass} bindings…</p>;
  }
  if (!bindings.length) {
    return (
      <p className="text-xs text-[#6B6358]">
        No {assetClass} bindings registered yet. Author one in the Brand Kit first.
      </p>
    );
  }
  return (
    <select
      data-testid={testid}
      value={value || ""}
      onChange={(e) => onChange(e.target.value || null)}
      className="w-full px-3 py-2 border border-[#1A1F2C]/20 rounded-md bg-[#F8F5EE]"
    >
      <option value="">— select binding —</option>
      {bindings.map((b) => (
        <option key={b.slug} value={b.slug}>
          {`${b.label} · ${b.slug}`}
        </option>
      ))}
    </select>
  );
}
